import { DMS_MODULE } from './constants';
import { router } from './router';
import { menu } from './menu';

export const Administrace = {
	name: DMS_MODULE,
	router,
	menu,
};
